import { render } from "./MyA.vue?vue&type=template&id=31a0199a&scoped=true"
import script from "./MyA.vue?vue&type=script&lang=js"
export * from "./MyA.vue?vue&type=script&lang=js"

import "./MyA.vue?vue&type=style&index=0&id=31a0199a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a0199a"]])

export default __exports__